import {InjectionToken} from '@angular/core';

export interface IExternalRedirect {
  ssoRedirect(url: string, replace?: boolean): void;
}

export const EXTERNAL_REDIRECT = new InjectionToken<IExternalRedirect>('EXTERNAL_REDIRECT');

